import {getSVG} from "../index";

// Tag/Beacon 3D icon - circular device with signal waves
const path = {
    0: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="25" cy="42" rx="12" ry="4"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M25 8 Q28 5 31 8" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M25 8 Q22 5 19 8" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    22: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="27" cy="42" rx="12" ry="4" transform="rotate(22 27 42)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M28 9 Q32 5 36 9" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M22 9 Q18 5 14 9" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    45: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="30" cy="40" rx="12" ry="4" transform="rotate(45 30 40)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M32 12 Q37 8 42 12" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M18 12 Q13 8 8 12" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    67: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="32" cy="38" rx="12" ry="4" transform="rotate(67 32 38)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M35 15 Q41 12 45 17" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M15 15 Q9 12 5 17" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    90: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="35" cy="35" rx="4" ry="12"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M38 22 Q42 19 42 25" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M12 22 Q8 19 8 25" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    112: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="35" cy="32" rx="4" ry="12" transform="rotate(22 35 32)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M40 28 Q44 26 43 32" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M10 28 Q6 26 7 32" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    135: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="33" cy="30" rx="4" ry="12" transform="rotate(45 33 30)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M38 33 Q43 33 40 38" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M12 17 Q7 17 10 12" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    157: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="30" cy="28" rx="4" ry="12" transform="rotate(67 30 28)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M35 38 Q38 42 32 43" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M15 12 Q12 8 18 7" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    180: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="25" cy="8" rx="12" ry="4"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle fill="#fff" cx="25" cy="25" r="2"/>
        <path fill="none" stroke="#232323" stroke-width="1.5" d="M25 42 Q28 45 31 42"/>
        <path fill="none" stroke="#232323" stroke-width="1.5" d="M25 42 Q22 45 19 42"/>`,

    202: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="20" cy="28" rx="4" ry="12" transform="rotate(-67 20 28)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M15 38 Q12 42 18 43" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M35 12 Q38 8 32 7" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    225: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="17" cy="30" rx="4" ry="12" transform="rotate(-45 17 30)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M12 33 Q7 33 10 38" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M38 17 Q43 17 40 12" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    247: (c, p, t, f) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}.cls-8{fill:${f};}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="15" cy="32" rx="4" ry="12" transform="rotate(-22 15 32)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-8" d="M10 28 Q6 26 7 32" fill="none" stroke="${f}" stroke-width="1.5"/>
        <path class="cls-6" d="M40 28 Q44 26 43 32" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    270: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="15" cy="35" rx="4" ry="12"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M12 22 Q8 19 8 25" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M38 22 Q42 19 42 25" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    292: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="18" cy="38" rx="12" ry="4" transform="rotate(-67 18 38)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M15 15 Q9 12 5 17" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M35 15 Q41 12 45 17" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    315: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="20" cy="40" rx="12" ry="4" transform="rotate(-45 20 40)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M18 12 Q13 8 8 12" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M32 12 Q37 8 42 12" fill="none" stroke="#232323" stroke-width="1.5"/>`,

    337: (c, p, t) => `
        <defs><style>.cls-1{fill:none;}.cls-2{opacity:0.3;}.cls-3{fill:${c};}.cls-4{fill:${p};}.cls-5{fill:${t};}.cls-6{fill:#232323;}.cls-7{fill:#fff;}</style></defs>
        <rect class="cls-1" width="50" height="50"/>
        <ellipse class="cls-2" cx="23" cy="42" rx="12" ry="4" transform="rotate(-22 23 42)"/>
        <circle class="cls-3" cx="25" cy="25" r="14"/>
        <circle class="cls-4" cx="25" cy="25" r="10"/>
        <circle class="cls-5" cx="25" cy="25" r="5"/>
        <circle class="cls-7" cx="25" cy="25" r="2"/>
        <path class="cls-6" d="M22 9 Q18 5 14 9" fill="none" stroke="#232323" stroke-width="1.5"/>
        <path class="cls-6" d="M28 9 Q32 5 36 9" fill="none" stroke="#232323" stroke-width="1.5"/>`,
};

const darkenColor = (hex, percent) => {
    let num = parseInt(hex.replace("#", ""), 16);
    let r = Math.floor((num >> 16) * (1 - percent));
    let g = Math.floor(((num >> 8) & 0x00FF) * (1 - percent));
    let b = Math.floor((num & 0x0000FF) * (1 - percent));
    return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
};

export default (degrees, color) => {
    const _degrees = Math.floor(Math.floor(degrees / 22.5) * 22.5) % 360
    return getSVG(path[_degrees](
        color, darkenColor(color, 0.4), darkenColor(color, 0.7), '#3498DB'
    ))
}
